onComplete(function() {
	// The header logo shrinks once the page scrolls, so the sticky header takes less room.
	var header = document.querySelector('.nav-header');
	if (header) {
		var update = function() {
			header.classList.toggle('is-scrolled', window.scrollY > 10);
		};
		window.addEventListener('scroll', update, { passive: true });
		update();
	}
});
